export default [
  {
    path: '/app/reports/summary',
    name: 'ReportSummary',
    component: () => import('@/views/Admin/Reports/Summary/Index.vue'),
    meta: {
      pageTitle: 'Raporlar',
      breadcrumb: [
        {
          text: 'Güncel Durum',
          active: true,
        },
      ],
      resource: 'ADMIN_REPORTS',
      action: 'read',
    },
  },
  {
    path: '/app/reports/incomes',
    name: 'ReportIncomes',
    component: () => import('@/views/Admin/Reports/Incomes/Index.vue'),
    meta: {
      pageTitle: 'Raporlar',
      breadcrumb: [
        {
          text: 'Gelirler Raporu',
          active: true,
        },
      ],
      resource: 'ADMIN_REPORTS',
      action: 'read',
    },
  },
  {
    path: '/app/reports/expenses',
    name: 'ReportExpenses',
    component: () => import('@/views/Admin/Reports/Expenses/Index.vue'),
    meta: {
      pageTitle: 'Raporlar',
      breadcrumb: [
        {
          text: 'Giderler Raporu',
          active: true,
        },
      ],
      resource: 'ADMIN_REPORTS',
      action: 'read',
    },
  },
  {
    path: '/app/reports/banks',
    name: 'ReportBanks',
    component: () => import('@/views/Admin/Reports/Banks/Index.vue'),
    meta: {
      pageTitle: 'Raporlar',
      breadcrumb: [
        {
          text: 'Banka Raporu',
          active: true,
        },
      ],
      resource: 'ADMIN_REPORTS',
      action: 'read',
    },
  },
  {
    path: '/app/reports/safes',
    name: 'ReportSafes',
    component: () => import('@/views/Admin/Reports/Safes/Index.vue'),
    meta: {
      pageTitle: 'Raporlar',
      breadcrumb: [
        {
          text: 'Kasa Raporu',
          active: true,
        },
      ],
      resource: 'ADMIN_REPORTS',
      action: 'read',
    },
  },
  {
    path: '/app/reports/director',
    name: 'ReportDirectory',
    component: () => import('@/views/Admin/Reports/Director/Index.vue'),
    meta: {
      pageTitle: 'Raporlar',
      breadcrumb: [
        {
          text: 'Yönetim Kurulu Raporu',
          active: true,
        },
      ],
      resource: 'ADMIN_REPORTS',
      action: 'read',
    },
  },
]
